export default "__VITE_ASSET__BQy9ejtx__"